import type { Lang } from "@noli/core";

export enum Captcha_Words {
  success_message = "success_message",
  fail_message = "fail_message",
  refresh_captcha = "refresh_captcha",
  captcha_input_placeholder = "captcha_input_placeholder",
  validate_title = "validate_title",
  cancel = "cancel",
  submit = "submit",
  validate_input = "validate_input",
}

export const captchaLangRecords: Record<Lang, Record<Captcha_Words, string>> = {
  zh: {
    success_message: "验证成功！",
    fail_message: "验证失败，请重试",
    refresh_captcha: "换一换",
    captcha_input_placeholder: "请输入图案计算结果",
    validate_title: "校验",
    cancel: "取消",
    submit: "验证",
    validate_input: "请输入计算结果",
  },
  en: {
    success_message: "Validation is passed 🥳",
    fail_message: "Validation is failed, please try again 😫",
    refresh_captcha: "Refresh",
    captcha_input_placeholder: "Please input the result",
    validate_title: "Validation",
    cancel: "Cancel",
    submit: "Submit",
    validate_input: "Please input the result of calculation",
  },
};
